<template>

    <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
        <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent' : ''">
            <div class="row align-items-center">
                <div id="errorNotification" class="col-md-12">
                    <base-alert v-if="errorMessage != null" type="danger">
                        <span class="alert-inner--text"> {{ errorMessage }}</span>
                        <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </base-alert>
                    <base-alert v-if="successMessage != null" type="success">
                        <span class="alert-inner--text"> {{ successMessage }}</span>
                        <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </base-alert>
                </div>
                <div class="col-md-3">
                    <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
                        PDE Viewing Tool
                    </h3>
                </div>
            </div>
        </div>

        <a-spin :spinning="loading" tip="Loading...">
            <div class="table-responsive">
                <vuetable ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields"
                    :sort-order="sortOrder" :show-sort-icons="true" :per-page="10" :row-class="rowClass" :css="css.table" pagination-path=""
                    data-path="data" no-data-template="Empty" @vuetable:checkbox-toggled-all="log"
                    @vuetable:checkbox-toggled="log" @vuetable:loading="loadStart" @vuetable:load-success="loadSuccess" @vuetable:load-error="onLoadError"
                    @vuetable:pagination-data="onPaginationData">

                    <template slot="actions" slot-scope="props">
                        <center>
                            <button class="btn btn-primary btn-sm" @click.prevent="viewDetails(props.rowData.order_details)">
                                View Details
                            </button>
                        </center>
                    </template>
                </vuetable>
            </div>

            <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent' : ''">
                <div class="pagination ui basic segment grid">
                    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination">
                    </vuetable-pagination>
                </div>
            </div>
        </a-spin>

        <a-drawer :visible="drawerVisible" :width="600" placement="right" @close="onClose">
            <h6 class="heading-small text-muted mb-4">Order Details</h6>
            <vuetable ref="details-table" :api-mode="false" :data="order_details" :css="css.table" :fields="detailsFields" :row-class="detailsRowClass" />
        </a-drawer>
    </div>
</template>

<script>
import {
    mapState
} from 'vuex'

import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import secureStorage from '../../controllers/secureStorage';
import HTTPRequest from '../../controllers/httpRequest.js';
import moment from 'moment';

var component_x;

export default {
    name: 'profiles-table',
    props: {
        type: {
            type: String
        },
        title: String,
        filterText: Object
    },
    components: {
        Vuetable,
        VuetablePagination
    },
    computed: {
        ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'serverType'])
    },
    data() {
        return {
            filterStatus: "",
            profileAction: "",
            errorMessage: null,
            successMessage: null,
            componentKey: 0,
            visible: false,
            availableFields: [],
            apiURL: "",
            fields: [
                { name: "name", title: "Terminal" },
                { name: "order_adjnet_pde", title: "PDE Order AdjNet" },
                { name: "order_adjnet_mms", title: "MMS Order AdjNet" },
                { name: "eod_adjnet_pde", title: "PDE EOD Adjnet" },
                { name: "eod_adjnet_mms", title: "MMS EOD Adjnet" },
                '__slot:actions'
            ],
            sortOrder: [{
                field: "site_id",
                direction: "asc"
            }],
            httpOptions: {
                headers: {
                    Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source': "BXI-File"
                }
            },
            css: {
                table: {
                    tableClass: 'table table-sm table-striped table-bordered table-hovered',
                    loadingClass: 'loading'
                },
                pagination: {
                    infoClass: 'pull-right',
                    wrapperClass: 'vuetable-pagination pull-right',
                    activeClass: 'btn-primary btn-sm',
                    disabledClass: 'disabled',
                    pageClass: 'btn btn-border',
                    linkClass: 'btn btn-border',
                    icons: {
                        first: '',
                        prev: '',
                        next: '',
                        last: '',
                    },
                }
            },
            loading: true,
            drawerVisible: false,
            order_details: [],
            detailsFields: [
                { name: "trans_id", title: "Trans ID" },
                { name: "pde_status", title: "PDE Status" },
                { name: "mms_status", title: "MMS Status" },
                { name: "pde_adjnet", title: "PDE AdjNet" },
                { name: "mms_adjnet", title: "MMS AdjNet" },
            ]
        }
    },
    watch: {
        currentApiURL: function () {
            this.$refs.vuetable.resetData()
            // this.apiURL = this.currentApiURL
            this.apiURL = this.endPoint + 'pde_viewing'
        },
        parameters: function () {
            // this.apiURL = this.currentApiURL
            // this.apiURL = this.apiURL + this.parameters
            this.apiURL = this.endPoint + 'pde_viewing' + this.parameters
            this.$refs.vuetable.selectedTo = []
            this.checkedItems = []
            console.log(this.filterText)
        }
    },
    methods: {
        moment,
        removeMessage(type) {
            if (type == 'error')
                this.errorMessage = null
            else
                this.successMessage = null
        },
        async onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
        },
        async onLoadError(error) {
            if (error.response.status == 401) {
                var auth_response = await HTTPRequest.authenticate(component_x.endPoint)
                if (auth_response["status"] == "Ok") {
                    this.$router.go();
                } else {
                    alert("Cannot get access token. Please login again.")
                    this.$router.push("/")
                }
            } else {
                if (error.response.data.error == "Session expired") {
                    alert("Session is already expired. Please login again.")
                    document.getElementById("logoutButton").click()
                }
            }
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        log() {
            this.checkedItems = this.$refs.vuetable.selectedTo
        },
        loadStart () {
            this.loading = true
            console.log("load start")
        },
        loadSuccess () {
            this.loading = false
            console.log("load success")
        },
        async viewDetails(order_details) {
            this.drawerVisible = true
            this.order_details = order_details
        },
        onClose() {
            this.drawerVisible = false
            this.order_details = []
        },
        isWithinTolerance(a, b, tolerance = 0.05) {
            const x = parseFloat(a) || 0
            const y = parseFloat(b) || 0
            return Math.abs(x - y) <= tolerance
        },

        rowClass(rowData) {
            const values = [
                rowData.order_adjnet_pde,
                rowData.order_adjnet_mms,
                rowData.eod_adjnet_pde,
                rowData.eod_adjnet_mms
            ].map(v => parseFloat(v) || 0)

            const tolerance = 0.05
            const first = values[0]

            const allMatch = values.every(v => Math.abs(v - first) <= tolerance)

            return allMatch ? 'row-green' : 'row-red'
        },
        detailsRowClass(rowData) {
            // Map statuses to their equivalences
            const statusMap = {
                'CA': 'A',
                'ST': 'P',
                'RF': 'V'
            }

            const pdeStatus = statusMap[rowData.pde_status] || rowData.pde_status
            const mmsStatus = statusMap[rowData.mms_status] || rowData.mms_status

            // Compare statuses
            const statusMatch = pdeStatus === mmsStatus

            // Compare adjnet values as before
            const adjnetValues = [
                rowData.pde_adjnet,
                rowData.mms_adjnet
            ].map(v => parseFloat(v) || 0)

            const avg = adjnetValues.reduce((a, b) => a + b, 0) / adjnetValues.length
            const adjnetMatch = adjnetValues.every(v => Math.abs(v - avg) <= 0.05)

            // Row is green only if statuses match and adjnets match
            return (statusMatch && adjnetMatch) ? 'row-green' : 'row-red'
        }
    },
    mounted: function () {
        component_x = this;
        this.apiURL = this.endPoint + 'pde_viewing' + this.parameters
    }
}
</script>

<style>
    .row-green {
        background-color: #d4edda !important;
    }

    .row-red {
        background-color: #f8d7da !important;
    }
</style>